"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const recording_to_recordingmodel_1 = require("@App/helpers/recording-to-recordingmodel");
const clean_name_1 = __importDefault(require("@App/helpers/clean-name"));
const ExtendedWorkWriterFields = ({ work }) => {
    var _a, _b, _c, _d, _e, _f;
    const filteredWriters = (_a = work.writers) === null || _a === void 0 ? void 0 : _a.map((writer) => (0, clean_name_1.default)(writer.firstName, writer.lastName)).filter(Boolean);
    const recordingCount = work.submissionId ? work.recordings.length : (_c = (_b = work.matchedRecordings) === null || _b === void 0 ? void 0 : _b.count) !== null && _c !== void 0 ? _c : 0;
    const recordingsToDisplay = work.submissionId
        ? work.recordings
        : (_f = (_e = (_d = work.matchedRecordings) === null || _d === void 0 ? void 0 : _d.recordings) === null || _e === void 0 ? void 0 : _e.map(recording_to_recordingmodel_1.mapRecordingToRecordingModel)) !== null && _f !== void 0 ? _f : [];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'names-list' },
            react_1.default.createElement("div", null,
                "Writers (",
                filteredWriters.length,
                ")"),
            react_1.default.createElement("div", null, filteredWriters.join(', '))),
        react_1.default.createElement("div", { className: 'names-list' },
            react_1.default.createElement("div", null,
                "Recording Artists (", recordingCount !== null && recordingCount !== void 0 ? recordingCount : 0,
                ")"),
            react_1.default.createElement("div", null, recordingsToDisplay.map((recording) => recording.artistName).join(', ')))));
};
exports.default = ExtendedWorkWriterFields;
